module.exports = __webpack_public_path__ + "assets/2_2_1_IFOK_WIM_INTEROPERABILITY_STANDARDS_platform_for_svg_je.0a7ac4e3.svg";